import { __decorate } from "tslib";
import { EType } from '@blade/common/interfaces/user-group';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { Component, Vue } from 'vue-property-decorator';
import { handleError } from '@blade/common/utils/handle-error';
import { mapTags } from '@blade-sxp/pass/utils/map-tree';
import TreePopover from '@blade-sxp/pass/components/tree-popover.vue';
import { validateOnlyAlphanumeric } from '@blade/common/utils/validate';
let default_1 = class extends Vue {
    title = '';
    form = { user_name: '', access: '' };
    tags = [];
    id = '';
    data = [];
    get whitegroup() {
        return {
            user_name: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!value) {
                        callback(new Error(this.$t('groupError').toString()));
                    }
                    else if (!validateOnlyAlphanumeric(value)) {
                        callback(new Error(this.$t('passManagement.groupNameError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
        };
    }
    handleClick(e) {
        const res = e.filter((item) => item.type && Number(item.type) === 1);
        console.log('tags:', e);
        this.tags = res;
    }
    handleClose(e) {
        const res = this.tags.filter((item) => item.id !== e.id);
        this.tags = res;
    }
    handleDelete() {
        this.tags = [];
    }
    mounted() {
        const { meta, params } = this.$route;
        console.log('router:', meta);
        this.title = meta.page;
        this.id = params.id;
        if (meta.page === 'editPortraitLibrary') {
            this.getWhite();
        }
    }
    handleSubmit() {
        this.$refs['group-form'].validate((valid) => {
            if (valid) {
                if (this.title === 'createPortraitLibrary') {
                    this.createStaff();
                }
                else {
                    this.updateStaff();
                }
            }
            else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    async getWhite() {
        try {
            const res = await StaffModule.getStaffById(this.id);
            console.log('res:', res);
            this.form.user_name = res.data.name;
            this.tags = mapTags(res.data);
            // console.log("tags:", this.tags)
        }
        catch (e) { }
    }
    async createStaff() {
        const res = this.tags.length > 0 ? this.tags.map((item) => item.id) : [];
        console.log('res:', res);
        try {
            await StaffModule.createStaff({
                maxSize: 0,
                name: this.form.user_name,
                remark: '',
                personGroup: EType.USER,
                userIds: res,
            });
            this.$elmessage.success(this.$t('whiteGroup').toString());
            this.$router.push({ path: '/users/portraitmanagement/pass', query: { group: 'GROUP' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    async updateStaff() {
        const res = this.tags.length > 0 ? this.tags.map((item) => item.id) : [];
        try {
            await StaffModule.updateStaff({
                id: this.id,
                name: this.form.user_name,
                remark: '',
                userIds: res,
            });
            this.$elmessage.success(this.$t('editSuccess').toString());
            this.$router.push({ path: '/users/portraitmanagement/pass', query: { group: 'GROUP' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    handleCancel() {
        this.$router.push({ path: '/users/portraitmanagement/pass', query: { group: 'GROUP' } });
    }
};
default_1 = __decorate([
    Component({
        components: { TreePopover },
        name: 'WhiteGroup',
        i18n: {
            messages: {
                'en-us': {
                    upload: 'Please upload the portrait',
                    createWhiteGroup: 'Create Portrait Library',
                    groupName: 'Portrait Library Name',
                    groupAccess: 'Portrait Library Access',
                    access: 'Please input name/organization',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    editWhiteGroup: 'Edit Portrait Library',
                    groupError: 'Please input Portrait Library',
                    groupNumber: 'Portrait Library Number',
                    remark: 'Remark',
                    gNumberE: 'Please input number',
                    whiteGroup: 'Successfully created Portrait Library',
                    editSuccess: 'Successfully edited',
                    createPortraitLibrary: 'Create Portrait Library',
                    editPortraitLibrary: 'Edit Portrait Library',
                },
                zh: {
                    upload: '请上传人像',
                    createWhiteGroup: '创建人像库',
                    groupName: '人像库名称',
                    groupAccess: '人像库权限',
                    access: '请输入姓名/部门',
                    submit: '确认',
                    cancel: '取消',
                    editWhiteGroup: '编辑人像库',
                    groupError: '请输入人像库名称',
                    groupNumber: '人像库数量',
                    remark: '备注',
                    gNumberE: '请输入人像库数量',
                    whiteGroup: '成功创建人像库',
                    editSuccess: '修改成功',
                    createPortraitLibrary: '创建人像库',
                    editPortraitLibrary: '修改人像库',
                },
            },
        },
    })
], default_1);
export default default_1;
